import { post, put } from "@/modules/request";

export const ApiPostReport = (params: {
  reason: string;
  reportableType: string; // collection, gal_game, mate, module_question,moment,reply,story,story_book
  reportableId: number;
}) => post("/Report/0", params);

export const ApiPutReplyBlockOne = (id: number) => put(`/Reply/BlockOne/${id}`);

export const ApiPostUserBlockOne = (blockedUserId: number) =>
  post(`/UserBlock/0`, { blockedUserId });
